<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"  
  >
    <path d="M2.0484e-08 2.56221C-0.000176996 1.14697 1.14696 -0.000177104 2.56221 2.05088e-08L13.4358 0.00135934C14.851 0.00153614 15.9985 1.14897 15.9986 2.56421L16 13.4378C16.0002 14.853 14.853 16.0002 13.4378 16L2.56421 15.9986C1.14897 15.9985 0.00153647 14.851 0.00135934 13.4358L2.0484e-08 2.56221ZM2.56237 1.28127C1.85475 1.28118 1.28118 1.85475 1.28127 2.56238L1.28263 13.4359C1.28271 14.1436 1.85643 14.7173 2.56406 14.7174L13.4376 14.7187C14.1452 14.7188 14.7188 14.1452 14.7187 13.4376L14.7174 2.56405C14.7173 1.85643 14.1436 1.28272 13.4359 1.28263L2.56237 1.28127Z" />
  </svg>
</template>
